module.exports = __webpack_public_path__ + "static/media/escudo-toty.68fd209f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/escudo-toty.jpg
// module id = 1292
// module chunks = 0